import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Container, Header, Input, Segment, Table } from 'semantic-ui-react';
import { toast } from 'react-semantic-toasts';
import request from '../../../../utils/request';
import tableStyles from '../../../../styles/table.module.scss';
import DeleteAction from '../../../../components/admin/DeleteAction';
import Pagination from '../../../../components/admin/Pagination';

const { Cell, HeaderCell, Row} = Table;
let timer = 0;

class AdminAssetsListView extends React.Component
{
    state = {
        isLoading: false,
        query: '',
        pagination: {},
        assets: [],
    };

    /**
     * Mount
     */
    componentDidMount = () => {
        this.fetch(1);
    }

    /**
     * Delete asset
     */
    deleteAsset = (asset) => {
        request.delete(`admin/assets/${asset.id}`).then(() => {
            this.fetch();

            toast({
                type: 'success',
                icon: '',
                description: 'Asset deleted succesfully',
                time: 2500,
            });
        });
    }

    /**
     * Fetch
     */
    fetch = (page) => {
        request(`admin/assets?q=${this.state.query}&page=${page || 1}`).then(({ data }) => {
            this.setState({
                isLoading: false,
                pagination: data.meta,
                assets: data.data,
            });
        });
    }

    /**
     * Search
     */
    searchAssets = (query) => {
        clearTimeout(timer);

        this.setState({
            isLoading: true,
            query,
        });

        timer = setTimeout(() => { this.fetch(1); }, 300);
    }

    // --- render
    render() {
        const { isLoading, pagination, query, assets } = this.state;

        return (
            <Container className="admin-page">
                <Segment padded>
                    <div className="admin-page-header">
                        <Header as="h1">Assets</Header>
                        <div>
                            <Link to="/admin/assets/sort">
                                <Button basic>Sort</Button>
                            </Link>
                            <Link to="/admin/assets/create">
                                <Button primary icon="plus" />
                            </Link>
                        </div>
                    </div>
                    <Input
                        fluid
                        loading={isLoading}
                        placeholder='Search...'
                        onChange={(e) => { this.searchAssets(e.target.value); }}
                        value={query}
                    />
                    <Table>
                        <Table.Header>
                            <Row>
                                <HeaderCell>Title</HeaderCell>
                                <HeaderCell>Author</HeaderCell>
                                <HeaderCell>Categories</HeaderCell>
                                <HeaderCell>Type</HeaderCell>
                                <HeaderCell>Languages</HeaderCell>
                                <HeaderCell singleLine textAlign="right">Actions</HeaderCell>
                            </Row>
                        </Table.Header>
                        <Table.Body>
                            {assets.map((asset) => (
                                <Row key={asset.id}>
                                    <Cell>
                                        <Link to={`/admin/assets/${asset.id}`}>
                                            {asset.title}
                                        </Link>
                                    </Cell>
                                    <Cell>{asset.author}</Cell>
                                    <Cell>{asset.categories.map(c => c.name).join(', ')}</Cell>
                                    <Cell>{asset.type}</Cell>
                                    <Cell>{asset.files.length ? asset.files.map(f => f.locale.toUpperCase()).join(', ') : null}</Cell>
                                    <Cell collapsing textAlign="right">
                                        <Link to={`/admin/assets/${asset.id}`}>
                                            <Button
                                                basic
                                                size="mini"
                                                icon="pencil"
                                            />
                                        </Link>
                                        <span className={tableStyles.actionsDivider}> | </span>
                                        <DeleteAction
                                            message="Are you sure you want to delete this asset?"
                                            onDelete={() => { this.deleteAsset(asset); }}
                                        />
                                    </Cell>
                                </Row>
                            ))}
                        </Table.Body>
                    </Table>
                </Segment>
                <Pagination data={pagination} onClick={this.fetch} />
            </Container>
        );
    }
}

export default AdminAssetsListView;
